import { Component, EventEmitter, Input, Output } from '@angular/core';

@Component({
  selector: 'mojo-pipeline-filters',
  templateUrl: './pipeline-filters.component.html',
})
export class PipelineFiltersComponent {
  @Input() selectedDepartment: string;
  @Input() selectedFunction: string;
  @Input() jobStatus: string;

  @Output() changeFilterParams = new EventEmitter();
  @Output() changeJobStatus = new EventEmitter();
  @Output() changeCandidateOrHiringManager = new EventEmitter();

  applyFilters(event) {
    this.changeFilterParams.emit({
      selectedFunction: event.selectedFunction,
      selectedDepartment: event.selectedDepartment,
    });
  }

  jobStatusFilterChanged(selectedJobStatus) {
    this.changeJobStatus.emit({
      selectedJobStatus,
    });
  }
  applyCandidateOrHiringManager(selectedCandidateOrHiringManager) {
    this.changeCandidateOrHiringManager.emit(selectedCandidateOrHiringManager);
  }
}
